<template>
    <div class="table-action-buttons">
        <i v-if="this.$can('update-types')" class="fa fa-edit fa-lg pointer" @click="edit" :title="uLang('app.configure_setting', { setting: lang('app.' + this.data.name) })"></i>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import store from '~/store'

    export default {
        name: 'actions',
        props: ['data', 'index'],

        computed: mapGetters({
            user: 'authUser'
        }),

        methods: {
            edit() {
                this.$router.push({ name: 'admin.settings.edit', params: { id: this.data.id }})
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>